module.exports = () => {
  return {
    filtering: {
      value: {},
      children: {
        name: {
          type: 'input',
          props: {
            placeholder: '请输入渠道包名称',
          },
          value: '',
        },
      },
    },
  };
};
